
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/junction",
      function () {
        return require("private-next-pages/success-stories/junction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/junction"])
      });
    }
  